import React from "react";
import { Link } from "react-router-dom";

import "./404.css";

const NotFound404 = () => (
  <div className="bg-image">
    <div className="flex h-screen justify-center items-center overflow-y-hidden">
      <div className="box">
        <div className="text-3xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-black pb-6">
          404
        </div>
        <div className="text-lg md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-black font-700 pb-6">
          Page Not Found
        </div>
        <div className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl mt-2 text-center text-black font-400 px-2%">
          <p>Looks like this page doesn't exist.</p>
          <p>But don't let that stop you!</p>
        </div>
        <div className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl mt-2 text-black font-400 px-1% pt-2">
          Head back to the home page right away!
        </div>
        <Link to="/">
          <div className="mt-8 font-semibold py-2 px-4 cursor-pointer btn">
            <span className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl text-black">
              Go Back
            </span>
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound404;
